import { CheckBoxItem } from "./CheckBoxItem";

export default CheckBoxItem;
